import React from "react";
import eight_slider_1 from '../../assets/eight_slider_1.avif';
import eight_slider_2 from '../../assets/eight_slider_2.avif';
import eight_slider_3 from '../../assets/eight_slider_3.avif';
import eight_slider_4 from '../../assets/eight_slider_4.avif';
import eight_slider_5 from '../../assets/eight_slider_5.avif';
import eight_slider_6 from '../../assets/eight_slider_6.avif';
import eight_slider_7 from '../../assets/eight_slider_7.avif';
import eight_slider_8 from '../../assets/eight_slider_8.avif';
import eight_slider_9 from '../../assets/eight_slider_9.avif';
import eight_slider_10 from '../../assets/eight_slider_10.avif';
import eight_slider_11 from '../../assets/eight_slider_11.avif';
import eight_slider_12 from '../../assets/eight_slider_12.avif';

const showcaseItems = [
  { img: eight_slider_1, title: 'Кейс: Брендинг сети ресторанов', price: 'Рост 200%', category: 'Брендинг' },
  { img: eight_slider_2, title: 'Кейс: SMM для fashion-бренда', price: '+150% подписчиков', category: 'SMM' },
  { img: eight_slider_3, title: 'Кейс: Контекстная реклама', price: 'ROI 450%', category: 'Реклама' },
  { img: eight_slider_4, title: 'Кейс: Разработка сайта', price: 'Конверсия +80%', category: 'Веб-разработка' },
  { img: eight_slider_5, title: 'Кейс: Видеореклама', price: 'Просмотры 2M+', category: 'Видео' },
  { img: eight_slider_6, title: 'Кейс: Таргетинг в Instagram', price: 'CPC снижен на 60%', category: 'Таргетинг' },
  { img: eight_slider_7, title: 'Кейс: SEO-продвижение', price: 'ТОП-3 по 50+ запросам', category: 'SEO' },
  { img: eight_slider_8, title: 'Кейс: Комплексная кампания', price: 'Продажи +350%', category: '360° кампания' },
  { img: eight_slider_9, title: 'Кейс: PR-кампания', price: 'Упоминаний +500%', category: 'PR' },
  { img: eight_slider_10, title: 'Кейс: Email-маркетинг', price: 'Доходимость 85%', category: 'Email' },
  { img: eight_slider_11, title: 'Кейс: Дизайн упаковки', price: 'Узнаваемость +120%', category: 'Дизайн' },
  { img: eight_slider_12, title: 'Кейс: Мобильный маркетинг', price: 'Установки +400%', category: 'Мобильный' },
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const GraphicAssetsShowcase = () => {
  return (
    <section className="bg-bg pb-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Портфолио
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Наши кейсы и результаты
            </h2>
          </div>
          
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
            Смотреть все кейсы <Icon name="arrow" size={13} />
          </button>
        </div>

        {/* Сетка: 4 колонки в ряд */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {showcaseItems.map((item, index) => (
            <article
              key={index}
              className="group flex flex-col overflow-hidden rounded-xl border border-line-strong bg-surface transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)]"
            >
              {/* Фотография кейса */}
              <div className="aspect-[4/3] w-full overflow-hidden bg-surface">
                <img
                  src={item.img}
                  alt={item.title}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
              </div>

              {/* Текстовая часть */}
              <div className="flex flex-1 flex-col justify-between border-t border-surface-2 bg-surface p-4">
                <div>
                  <span className="inline-block rounded bg-accent-soft px-2 py-0.5 text-[10px] font-medium text-accent mb-2">
                    {item.category}
                  </span>
                  
                  <h3 className="text-xs font-medium leading-snug text-content transition-colors group-hover:text-accent-hover">
                    {item.title}
                  </h3>
                </div>

                <div className="mt-4 flex items-center justify-between border-t border-surface-2 pt-3">
                  <span className="text-[11px] font-light text-muted">Результат:</span>
                  <span className="text-xs font-semibold text-accent">{item.price}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Кнопка внизу */}
        <div className="mt-8 text-center">
          <button className="inline-flex items-center gap-2 rounded-lg border border-line-strong bg-surface px-6 py-2.5 text-xs font-medium text-content transition hover:border-accent-hover hover:text-accent-hover">
            Все кейсы <Icon name="arrow" size={13} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default GraphicAssetsShowcase;